import React from 'react'

import { makeStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

const useStyles = makeStyles(theme => ({
  destination_filter: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: 32
  },
  destination_filter_fake_option: {
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    borderBottom: '2px solid #D2D5D8'
  },
  destination_filter_option: {
    display: 'flex',
    justifyContent: 'center',
    width: '50%',
    borderBottom: '2px solid #D2D5D8',
    cursor: 'pointer',
    transition: 'border-color 0.3s ease-in-out',
    '& h1': {
      margin: 0,
      color: '#D2D5D8',
      fontSize: 15,
      fontWeight: 600,
      transition: 'color 0.3s ease-in-out',
      [theme.breakpoints.down('1498')]: {
        fontSize: 13
      },
      [theme.breakpoints.down('1280')]: {
        fontSize: 18
      },
      [theme.breakpoints.down('1280')]: {
        fontSize: 14
      },
      [theme.breakpoints.down('666')]: {
        fontSize: 10
      },
      [theme.breakpoints.down('600')]: {
        fontSize: 15
      }
    }
  },
  destination_filter_option_selected: {
    borderBottom: '2px solid #386093 !important',
    '& h1': {
      color: '#386093 !important'
    }
  }
}))

const TabNavigation = ({ options, keyClass }) => {
  const [selectedOption, setSelectedOption] = React.useState(options[0])
  const classes = useStyles()
  const handleChangeOption = item => {
    setSelectedOption(item)
    item?.handleChange && item.handleChange()
  }
  return (
    <div className={classes.destination_filter}>
      {options.map(item => {
        return (
          <div
            key={item.key}
            onClick={() => {
              handleChangeOption(item)
            }}
            className={`${
              item?.fakeOption
                ? classes.destination_filter_fake_option
                : classes.destination_filter_option
            } ${
              selectedOption.key === item.key
                ? classes.destination_filter_option_selected
                : ''
            }`}
          >
            <h1 className={keyClass}>{item.key}</h1>
          </div>
        )
      })}
    </div>
  )
}

export default TabNavigation

TabNavigation.propTypes = {
  options: PropTypes.array.isRequired,
  keyClass: PropTypes.object
}
